<template>
  <b-form @submit.prevent>
    <b-row class="mt-2">
      <b-col
        cols="12"
        class="text-center"
      >
        <h4>
          <feather-icon
            icon="CloudIcon"
            class="ml-1"
            size="20"
          />
          Datos de la conexión - <strong>{{ data.cloudType }}</strong>
        </h4>
        <b-form-textarea
          v-model="data.connection"
          class="mt-2"
          placeholder="Cadena de conexión"
          rows="3"
          readonly
        />
      </b-col>

      <!-- btn centered actions-->
      <b-col class="text-center mt-2">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="primary"
          class="ml-4"
          @click="close"
        >
          Cerrar
        </b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import {
  BForm, BRow, BCol,
  BButton, BFormTextarea,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BButton,
    BFormTextarea,
  },
  directives: {
    Ripple,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>
